.ticket-qty-selector {
  display: flex;
}
.ticket-qty-selector .form-control {
  width: 100px;
  max-width: 170px;
  text-align: center;
}
.ticket-qty-selector.right {
  justify-content: flex-end;
}
.ticket-qty-selector .error-message {
  margin-top: 15px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvanRyZW1ibGF5L3NvbHV0aW9uc3RsbS50aWNrZXRpbmdzeXN0ZW0vc3JjL3RzLmludGVybmV0c2FsZS4zLjAvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvb3JnYW5pc21zL3NlbGVjdHRpY2tldHMiLCJzb3VyY2VzIjpbInRpY2tldC1xdHktc2VsZWN0b3Iuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJOztBQUVBO0VBQ0k7RUFDQTtFQUNBOztBQUdKO0VBQ0k7O0FBR0o7RUFDSSIsInNvdXJjZXNDb250ZW50IjpbIi50aWNrZXQtcXR5LXNlbGVjdG9yIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuXG4gICAgLmZvcm0tY29udHJvbCB7XG4gICAgICAgIHdpZHRoOiAxMDBweDtcbiAgICAgICAgbWF4LXdpZHRoOiAxNzBweDtcbiAgICAgICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIH1cblxuICAgICYucmlnaHQge1xuICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xuICAgIH1cblxuICAgIC5lcnJvci1tZXNzYWdlIHtcbiAgICAgICAgbWFyZ2luLXRvcDoxNXB4O1xuICAgIH1cbn0iXX0= */